import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {AccountStatementDetails, AccountStatementDetailsListNetworkEntity, SelectedBuildingInterface} from '../types/interface.types';
import {Observable} from 'rxjs/Observable';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';


@Injectable()
export class CondomanagerService {

    accountStatementModalDetails: AccountStatementDetails[] = null;

    public isHasEntries = false;

    constructor(
        private api: ApiClientService
    ) {
    }

    /**
     * Receives account statement details
     * for selected suite in building
     */
    getStatementsList(buildingId: number, suiteNumber: string, params = null): Observable<AccountStatementDetailsListNetworkEntity> {
        const queryParams = {
            suiteNumber: suiteNumber,
            bdId: buildingId
        };
        for (const prop in params) {
            if (params.hasOwnProperty(prop) && params[prop]) {
                queryParams[prop] = params[prop];
            }
        }

        const queryString = Object.keys(queryParams)
            .map(key => `${key}=${queryParams[key].toString()}`)
            .join('&');

        return this.api.getJson('domainCondomanager', '/v1/journal?' + queryString)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity<any, AccountStatementDetails>(null, sourceNetworkEntity => {
                        return {
                            balance: sourceNetworkEntity.entities
                                .map(item => item.amount)
                                .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                        };
                    }
                ),
                catchError(error => {
                    console.error({error});
                    return of({
                        error,
                        entities: [],
                        balance: 0,
                        total: 0
                    } as any);
                }),
            );
    }

    // FIXME: hack as temporary solution
    public checkEntries() {
        const selectedBuilding = JSON.parse(localStorage.getItem('residentselectedBuilding')) as SelectedBuildingInterface;
        if (!selectedBuilding) { // available for resident only
            return;
        }

        const params = {'per-page': '1'};
        this.getStatementsList(selectedBuilding.buildingId, selectedBuilding.suiteNumber, params).subscribe(result => {
            this.isHasEntries = result.entities.length > 0;
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/condomanager.service.ts